import { useFormContext } from 'react-hook-form';

import { ServiceIndependentFormData } from '../RelatedService.schema';
import { CardColumn } from '../RelatedServiceCard';

type ServiceIndependentProps = {
  year: string;
};

export const ServiceIndependent = ({ year }: ServiceIndependentProps) => {
  const { watch } = useFormContext<ServiceIndependentFormData>();

  const formData = watch();

  return (
    <div className="mt-4 flex flex-col gap-6 border-t border-neutral-800 pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <CardColumn
          label={`${year} Start Date`}
          text={formData.startDate ? new Date(formData.startDate).toLocaleDateString() : ''}
        />

        <CardColumn label="Provider Name" text={formData.providerName} />

        <CardColumn label="Provider Phone Number" text={formData.providerPhoneNumber} />
      </div>
    </div>
  );
};
